module.exports = __webpack_public_path__ + "img/SWP_Shield_07 (2).468ce654.png";